export default __webpack_public_path__ + "static/media/map.8ca54026.png";